module.exports = __webpack_public_path__ + "10287c1eb2b654c8e5d0bd02c699aa2f.pdf";